export const initGtag = () => {
    if (window.gtag) return; // Prevent multiple initializations
  
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  
    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17044846885';
    document.head.appendChild(script);
  
    window.gtag('js', new Date());
    window.gtag('config', 'AW-17044846885');
  };
  
  export const trackConversion = (sendTo) => {
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: sendTo });
    }
  };